import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPromptText = memo((props: PropsWithChildren) => {
  return (
    <BodyText sizeMatch={['22']} style={styles.text}>
      {props.children}
    </BodyText>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.CREAM,
    marginBottom: theme.spacing['6'],
  },
});
